export default __webpack_public_path__ + "31d6bff53eb45e16c284b63aa38722fa.png";